var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from 'classnames';
import React, { useMemo } from 'react';
import { createPrefixCls } from '../_utils/string';
const prefixCls = createPrefixCls('badge');
export const Badge = (_a) => {
    var { children, className, count, dot = true, max, color } = _a, restProps = __rest(_a, ["children", "className", "count", "dot", "max", "color"]);
    const badgeCls = useMemo(() => {
        return classnames([prefixCls(), { [prefixCls('wrapper')]: children }, className]);
    }, [children, className]);
    const colorSty = {
        backgroundColor: color
    };
    return (React.createElement("div", Object.assign({ className: badgeCls }, restProps),
        children,
        count ? (React.createElement("div", { className: prefixCls('count'), style: colorSty }, max ? (count > max ? max + '+' : count) : count)) : count === 0 ? null : dot ? (React.createElement("div", { className: prefixCls('dot'), style: colorSty })) : null));
};
export default Badge;
